import tinycolor from 'tinycolor2'
import { ChartPatternBias } from '../util/IndicatorUtils/patterns/chartPatternTypes'

const CANDLESTICK_BACKGROUND_ALPHA = 20 / 255

/** TradingView-style label color input → overlay marker, label, and default background tint. */
export const buildCandlestickLabelColorStylePatch = (
    bias: ChartPatternBias,
    labelColor: string,
): Record<string, unknown> => {
    const markerColor = tinycolor(labelColor).setAlpha(1).toHexString()
    const backgroundHex8 = tinycolor(markerColor).setAlpha(CANDLESTICK_BACKGROUND_ALPHA).toHex8String()
    const labelKey = bias === 'bearish' ? 'labelColorBearish' : 'labelColorBullish'
    return {
        [labelKey]: markerColor,
        paneLabelColor: markerColor,
        priceLineColor: markerColor,
        neckLineColor: markerColor,
        backgroundColor: backgroundHex8,
        showBackground: true,
        showLineFills: true,
    }
}

/** Style-tab background swatch — only updates candle highlight fill, not label colors. */
export const buildCandlestickBackgroundStylePatch = (
    backgroundHex8: string,
    showBackground = true,
): Record<string, unknown> => ({
    backgroundColor: backgroundHex8,
    showBackground,
    showLineFills: showBackground,
})
